<template>
    <sw-notification position="md-top" />
    <sw-loading-full />

    <router-view/>
</template>

<script setup>
    // Este componente não precisa de lógica no script
</script>

<style lang="scss">
    @import '../src/assets/css/default.scss';
    @import '../src/assets/css/mediaScreen.scss';
    @import '../src/assets/css/helpers.scss';

    *, *::before, *::after{
        box-sizing: border-box;
        font-family: var(--fontFamilyPrimary);
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        font-feature-settings: "kern" 1;
        font-kerning: auto;
    }
    
    body, html{
        font-family: var(--fontFamilyPrimary);
        font-size: var(--fontSizeBase);
        line-height: var(--lineHeightNormal);
        font-weight: var(--fontWeightNormal);
        color: var(--textSecondary);
    }

    ::-webkit-scrollbar{
        background: var(--scrollbarBackground);
        width: var(--scrollbarWidth);
    }

    ::-webkit-scrollbar-thumb{
        background: var(--scrollbarThumb);
        border-radius: var(--scrollbarRadius);
    }

    ::-webkit-scrollbar-thumb:hover{
        background: var(--scrollbarThumbHover);
    }

    body{
        background: var(--backgroundBody) url('./assets/background-login.svg') center -265px no-repeat;
        height: 100%;
        color: var(--textSecondary);
    }

    body.bodyDashboard{
        background-color: var(--backgroundDashboard);
    }

    #app{
        width: 100%;
        height: 100%;
        min-height: 100%;
    }

    /**
        Animações
     */
    .routerFade-enter-active, .routerFade-leave-active {
        transition: all 1s ease;
    }
    .routerFade-enter, .routerFade-leave-to, .routerFade-leave{
        opacity: 0;
    }

    .notificationFade-enter-active, .notificationFade-leave-active {
      transition: all 0.3s ease-in-out;
      transform: scale(1);
      transform-origin: top right;
    }
    .notificationFade-enter, .notificationFade-leave-to{
      transform: scale(0);
    }

    .menuSlider-enter-active, .menuSlider-leave-active {
        transition: all 0.3s ease;
    }
    .menuSlider-enter, .menuSlider-leave-to, .menuSlider-leave{
        transform: translateX(-310px);
    }
</style>
